import { get } from './request'

export async function fetchAccounts() {
  const accounts = await get<any>('/accounts')
  return accounts
}
